// extracted by mini-css-extract-plugin
export default {"textContainer":"editable-text_textContainer__04DFW"};